import { CaseUpdatePresetFilterOptions } from '../../enums/filters-and-searchs/caseUpdatPreset.filter.options';

export const CaseUpdatePresetFilterOptionDetails = new Map<number, string>([
    [CaseUpdatePresetFilterOptions.None, 'None'],
    [CaseUpdatePresetFilterOptions.Deleted, 'Deleted Case Update Preset']

]);
